import { Controller } from "@hotwired/stimulus"
import JSZip from "jszip"

// Connects to data-controller="zip-download"
export default class extends Controller {
  static values = {
    urls: Array,
    filename: String
  }

  async download(event) {
    event.preventDefault()

    const button = event.currentTarget
    const originalText = button.textContent

    try {
      // Disable button and show progress
      button.disabled = true
      button.textContent = "Preparing download..."

      const zip = new JSZip()
      const total = this.urlsValue.length

      // Download each photo and add to ZIP
      for (let i = 0; i < total; i++) {
        const urlData = this.urlsValue[i]
        button.textContent = `Downloading ${i + 1}/${total}...`

        try {
          const response = await fetch(urlData.url)
          if (!response.ok) throw new Error(`Failed to fetch ${urlData.filename}`)

          const blob = await response.blob()
          zip.file(urlData.filename, blob)
        } catch (error) {
          console.error(`Failed to download ${urlData.filename}:`, error)
          // Continue with other files even if one fails
        }
      }

      // Generate ZIP file
      button.textContent = "Creating ZIP file..."
      const zipBlob = await zip.generateAsync({
        type: "blob",
        compression: "DEFLATE",
        compressionOptions: { level: 6 }
      })

      // Trigger download
      const url = URL.createObjectURL(zipBlob)
      const a = document.createElement("a")
      a.href = url
      a.download = this.filenameValue || "photos.zip"
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(url)

      button.textContent = "Download complete!"
      setTimeout(() => {
        button.textContent = originalText
        button.disabled = false
      }, 2000)

    } catch (error) {
      console.error("Failed to create ZIP:", error)
      button.textContent = "Download failed. Please try again."
      setTimeout(() => {
        button.textContent = originalText
        button.disabled = false
      }, 3000)
    }
  }
}
